import { render, staticRenderFns } from "./ItemTestPage.vue?vue&type=template&id=6ae08b01"
import script from "./ItemTestPage.vue?vue&type=script&lang=js"
export * from "./ItemTestPage.vue?vue&type=script&lang=js"
import style0 from "./ItemTestPage.vue?vue&type=style&index=0&id=6ae08b01&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports